import qs from 'qs';

export const buildQueryString = (params) => {
  return qs.stringify({
    page: params.page || undefined,
    search: params.searchParam || undefined,
    sort: params.sortParam || undefined,
    //дальше фильтры
    polnoves: params.fullLightWeightParam || undefined,
    type: params.tradeOfferTypeParam || undefined,
    color: params.colorMetalParam || undefined,
    material: params.materialParam || undefined,
    forwhom: params.forwhomParam || undefined,
    adres: params.storeParam || undefined,
    prob: params.probParam || undefined,
    category: params.categoryParam || undefined,
    subcategory: params.subcategoryParam || undefined,
    size: params.sizeParam || undefined,
    vstavki: params.vstavkiParam || undefined,
    vstavkidetail: params.vstavkiDetailParam || undefined,
    w_min: params.minWeightParam || undefined,
    w_max: params.maxWeightParam || undefined,
    min_price: params.minPriceParam || undefined,
    max_price: params.maxPriceParam || undefined,
  });
};
